import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Countdown from './Countdown';
import { promoActive } from '../common/promo';

const { FiArrowDown, FiArrowUpRight, FiMapPin } = FiIcons;

export default function Hero() {
  const promo = promoActive();
  return (
    <section className="hero" id="inicio">
      <div className="hero-glow" />
      <div className="hero-inner container">
        <div className="hero-copy">
          <div className="hero-kicker"><span className="tiny-line" /> ENCUENTRO PRESENCIAL · 14 DE NOVIEMBRE</div>
          <h1>ESCUELA DE<br /><em>LIDERAZGO<span>.</span></em></h1>
          <p className="hero-presenter">con <strong>Yahir Pérez</strong> <span>·</span> Equipo del Presidente</p>
          <div className="hero-divider" />
          <p className="hero-date"><SafeIcon icon={FiMapPin} /> Sábado 14 de noviembre de 2026 <span>·</span> Cuautitlán Izcalli, Estado de México</p>
          <p className="hero-description">Una tarde de entrenamiento con uno de los líderes que mejor enseña cómo formar y dirigir una organización.</p>
          <div className="hero-actions">
            <a className="button button-gold" href="#boletos">APARTAR MI LUGAR — $150 <SafeIcon icon={FiArrowUpRight} /></a>
            {promo && <a className="button button-outline" href="#boletos">6 BOLETOS — $800</a>}
          </div>
          <p className="capacity">Cupo limitado a 140 lugares{promo && ' · 6 boletos por $800 hasta el 31 de octubre'}</p>
        </div>
        <div className="hero-side">
          <div className="hero-monogram" aria-hidden="true">M</div>
          <Countdown />
        </div>
      </div>
      <a className="scroll-cue" href="#experiencia">DESCUBRE EL EVENTO <SafeIcon icon={FiArrowDown} /></a>
      <div className="hero-index">01 / 08</div>
    </section>
  );
}